let _stripe

export const stripe = () => {
  if (!_stripe) _stripe = Stripe(Constants.StripeId)

  return _stripe
}
